// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@7.1.4_webpack@5.105.2/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@7.1.4_webpack@5.105.2/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* =============================================================================
   VERTICAL LABEL LAYOUT
   ============================================================================= */
/* Clean, elegant vertical layout with labels positioned above form fields */

/* Reset floating label positioning */
/* .floating-label-input {
  position: static;
  margin-top: 0;
} */

/* Ensure inputs don't have extra top padding */
/* .floating-input {
  padding-top: var(--mantine-spacing-xs) !important;
} */

/* ============================================================================
   Vertical Layout Styles
   ============================================================================ */

.form-layout--vertical .phone-input-wrapper .phone-input-label {
  display: none;
}

.form-layout--vertical .country-select-wrapper .mantine-Select-label {
  display: none;
}

.form-layout--vertical .conversion-input .mantine-InputWrapper-label,
.form-layout--vertical [data-ui="conversion-input"] .mantine-InputWrapper-label {
  display: none;
}

.form-layout--vertical .conversion-input .mantine-Stack-root,
.form-layout--vertical [data-ui="conversion-input"] .mantine-Stack-root {
  gap: 0;
}

/* Follow the input size instead of a fixed height: Mantine derives --input-height
   from the size prop (sm 36px, md 42px, lg 50px). */
.form-layout--vertical .mantine-TextInput-input,
.form-layout--vertical .mantine-NumberInput-input,
.form-layout--vertical .mantine-Select-input,
.form-layout--vertical .mantine-DateInput-input,
.form-layout--vertical .mantine-DatePickerInput-input {
  height: var(--input-height);
  min-height: var(--input-height);
}

.form-layout--vertical .mantine-Textarea-input {
  min-height: 80px;
}

.form-layout--vertical .mantine-InputWrapper-root {
  margin-bottom: var(--mantine-spacing-xs);
}

.form-layout--vertical .mantine-InputWrapper-root .mantine-InputWrapper-label {
  font-size: var(--mantine-font-size-sm);
  font-weight: 500;
  color: var(--mantine-color-dark-5);
  text-transform: capitalize;
}

.form-layout--vertical .mantine-InputWrapper-root .mantine-InputWrapper-description {
  font-size: var(--mantine-font-size-xs);
  color: var(--mantine-color-gray-6);
  margin-bottom: 6px;
  line-height: var(--mantine-line-height);
}

.form-layout--vertical .mantine-InputWrapper-root .mantine-InputWrapper-error {
  font-size: var(--mantine-font-size-xs);
  font-weight: 600;
  margin-top: var(--mantine-spacing-xs);
}

.form-layout--vertical .conversion-input .mantine-InputWrapper-root,
.form-layout--vertical [data-ui="conversion-input"] .mantine-InputWrapper-root {
  margin-bottom: 0;
}

/* ============================================================================
   Validation Styles
   ============================================================================ */

.mantine-TextInput-input[data-invalid="true"],
.mantine-TextInput-input[aria-invalid="true"],
.mantine-Textarea-input[data-invalid="true"],
.mantine-Textarea-input[aria-invalid="true"],
.mantine-NumberInput-input[data-invalid="true"],
.mantine-NumberInput-input[aria-invalid="true"],
.mantine-Select-input[data-invalid="true"],
.mantine-Select-input[aria-invalid="true"],
.mantine-DateInput-input[data-invalid="true"],
.mantine-DateInput-input[aria-invalid="true"],
.mantine-DatePickerInput-input[data-invalid="true"],
.mantine-DatePickerInput-input[aria-invalid="true"] {
  background-color: var(--mantine-color-red-0);
  border-color: var(--mantine-color-red-6);
}

.mantine-TextInput-input[data-invalid="true"]:focus,
.mantine-TextInput-input[data-invalid="true"]:focus-within,
.mantine-TextInput-input[aria-invalid="true"]:focus,
.mantine-TextInput-input[aria-invalid="true"]:focus-within,
.mantine-Textarea-input[data-invalid="true"]:focus,
.mantine-Textarea-input[data-invalid="true"]:focus-within,
.mantine-Textarea-input[aria-invalid="true"]:focus,
.mantine-Textarea-input[aria-invalid="true"]:focus-within,
.mantine-NumberInput-input[data-invalid="true"]:focus,
.mantine-NumberInput-input[data-invalid="true"]:focus-within,
.mantine-NumberInput-input[aria-invalid="true"]:focus,
.mantine-NumberInput-input[aria-invalid="true"]:focus-within,
.mantine-Select-input[data-invalid="true"]:focus,
.mantine-Select-input[data-invalid="true"]:focus-within,
.mantine-Select-input[aria-invalid="true"]:focus,
.mantine-Select-input[aria-invalid="true"]:focus-within,
.mantine-DateInput-input[data-invalid="true"]:focus,
.mantine-DateInput-input[data-invalid="true"]:focus-within,
.mantine-DateInput-input[aria-invalid="true"]:focus,
.mantine-DateInput-input[aria-invalid="true"]:focus-within,
.mantine-DatePickerInput-input[data-invalid="true"]:focus,
.mantine-DatePickerInput-input[data-invalid="true"]:focus-within,
.mantine-DatePickerInput-input[aria-invalid="true"]:focus,
.mantine-DatePickerInput-input[aria-invalid="true"]:focus-within {
  border-color: var(--mantine-color-red-6);
  box-shadow: 0 0 0 1px var(--mantine-color-red-6);
}

.input-error-icon {
  color: var(--mantine-color-red-6);
  display: flex;
  align-items: center;
}

.mantine-InputWrapper-error {
  font-size: var(--mantine-font-size-xs);
  font-weight: 600;
}
`, "",{"version":3,"sources":["webpack://./../../packages/ui/src/styles/mantine-overrides.css"],"names":[],"mappings":"AAAA;;kFAEkF;AAClF,4EAA4E;;AAE5E,qCAAqC;AACrC;;;GAGG;;AAEH,+CAA+C;AAC/C;;GAEG;;AAEH;;iFAEiF;;AAEjF;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;;EAEE,aAAa;AACf;;AAEA;;EAEE,MAAM;AACR;;AAEA;oDACoD;AACpD;;;;;EAKE,2BAA2B;EAC3B,+BAA+B;AACjC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,sCAAsC;EACtC,gBAAgB;EAChB,kCAAkC;EAClC,0BAA0B;AAC5B;;AAEA;EACE,sCAAsC;EACtC,kCAAkC;EAClC,kBAAkB;EAClB,uCAAuC;AACzC;;AAEA;EACE,sCAAsC;EACtC,gBAAgB;EAChB,qCAAqC;AACvC;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;;iFAEiF;;AAEjF;;;;;;;;;;;;EAYE,4CAA4C;EAC5C,wCAAwC;AAC1C;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;EAwBE,wCAAwC;EACxC,gDAAgD;AAClD;;AAEA;EACE,iCAAiC;EACjC,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,sCAAsC;EACtC,gBAAgB;AAClB","sourcesContent":["/* =============================================================================\n   VERTICAL LABEL LAYOUT\n   ============================================================================= */\n/* Clean, elegant vertical layout with labels positioned above form fields */\n\n/* Reset floating label positioning */\n/* .floating-label-input {\n  position: static;\n  margin-top: 0;\n} */\n\n/* Ensure inputs don't have extra top padding */\n/* .floating-input {\n  padding-top: var(--mantine-spacing-xs) !important;\n} */\n\n/* ============================================================================\n   Vertical Layout Styles\n   ============================================================================ */\n\n.form-layout--vertical .phone-input-wrapper .phone-input-label {\n  display: none;\n}\n\n.form-layout--vertical .country-select-wrapper .mantine-Select-label {\n  display: none;\n}\n\n.form-layout--vertical .conversion-input .mantine-InputWrapper-label,\n.form-layout--vertical [data-ui=\"conversion-input\"] .mantine-InputWrapper-label {\n  display: none;\n}\n\n.form-layout--vertical .conversion-input .mantine-Stack-root,\n.form-layout--vertical [data-ui=\"conversion-input\"] .mantine-Stack-root {\n  gap: 0;\n}\n\n/* Follow the input size instead of a fixed height: Mantine derives --input-height\n   from the size prop (sm 36px, md 42px, lg 50px). */\n.form-layout--vertical .mantine-TextInput-input,\n.form-layout--vertical .mantine-NumberInput-input,\n.form-layout--vertical .mantine-Select-input,\n.form-layout--vertical .mantine-DateInput-input,\n.form-layout--vertical .mantine-DatePickerInput-input {\n  height: var(--input-height);\n  min-height: var(--input-height);\n}\n\n.form-layout--vertical .mantine-Textarea-input {\n  min-height: 80px;\n}\n\n.form-layout--vertical .mantine-InputWrapper-root {\n  margin-bottom: var(--mantine-spacing-xs);\n}\n\n.form-layout--vertical .mantine-InputWrapper-root .mantine-InputWrapper-label {\n  font-size: var(--mantine-font-size-sm);\n  font-weight: 500;\n  color: var(--mantine-color-dark-5);\n  text-transform: capitalize;\n}\n\n.form-layout--vertical .mantine-InputWrapper-root .mantine-InputWrapper-description {\n  font-size: var(--mantine-font-size-xs);\n  color: var(--mantine-color-gray-6);\n  margin-bottom: 6px;\n  line-height: var(--mantine-line-height);\n}\n\n.form-layout--vertical .mantine-InputWrapper-root .mantine-InputWrapper-error {\n  font-size: var(--mantine-font-size-xs);\n  font-weight: 600;\n  margin-top: var(--mantine-spacing-xs);\n}\n\n.form-layout--vertical .conversion-input .mantine-InputWrapper-root,\n.form-layout--vertical [data-ui=\"conversion-input\"] .mantine-InputWrapper-root {\n  margin-bottom: 0;\n}\n\n/* ============================================================================\n   Validation Styles\n   ============================================================================ */\n\n.mantine-TextInput-input[data-invalid=\"true\"],\n.mantine-TextInput-input[aria-invalid=\"true\"],\n.mantine-Textarea-input[data-invalid=\"true\"],\n.mantine-Textarea-input[aria-invalid=\"true\"],\n.mantine-NumberInput-input[data-invalid=\"true\"],\n.mantine-NumberInput-input[aria-invalid=\"true\"],\n.mantine-Select-input[data-invalid=\"true\"],\n.mantine-Select-input[aria-invalid=\"true\"],\n.mantine-DateInput-input[data-invalid=\"true\"],\n.mantine-DateInput-input[aria-invalid=\"true\"],\n.mantine-DatePickerInput-input[data-invalid=\"true\"],\n.mantine-DatePickerInput-input[aria-invalid=\"true\"] {\n  background-color: var(--mantine-color-red-0);\n  border-color: var(--mantine-color-red-6);\n}\n\n.mantine-TextInput-input[data-invalid=\"true\"]:focus,\n.mantine-TextInput-input[data-invalid=\"true\"]:focus-within,\n.mantine-TextInput-input[aria-invalid=\"true\"]:focus,\n.mantine-TextInput-input[aria-invalid=\"true\"]:focus-within,\n.mantine-Textarea-input[data-invalid=\"true\"]:focus,\n.mantine-Textarea-input[data-invalid=\"true\"]:focus-within,\n.mantine-Textarea-input[aria-invalid=\"true\"]:focus,\n.mantine-Textarea-input[aria-invalid=\"true\"]:focus-within,\n.mantine-NumberInput-input[data-invalid=\"true\"]:focus,\n.mantine-NumberInput-input[data-invalid=\"true\"]:focus-within,\n.mantine-NumberInput-input[aria-invalid=\"true\"]:focus,\n.mantine-NumberInput-input[aria-invalid=\"true\"]:focus-within,\n.mantine-Select-input[data-invalid=\"true\"]:focus,\n.mantine-Select-input[data-invalid=\"true\"]:focus-within,\n.mantine-Select-input[aria-invalid=\"true\"]:focus,\n.mantine-Select-input[aria-invalid=\"true\"]:focus-within,\n.mantine-DateInput-input[data-invalid=\"true\"]:focus,\n.mantine-DateInput-input[data-invalid=\"true\"]:focus-within,\n.mantine-DateInput-input[aria-invalid=\"true\"]:focus,\n.mantine-DateInput-input[aria-invalid=\"true\"]:focus-within,\n.mantine-DatePickerInput-input[data-invalid=\"true\"]:focus,\n.mantine-DatePickerInput-input[data-invalid=\"true\"]:focus-within,\n.mantine-DatePickerInput-input[aria-invalid=\"true\"]:focus,\n.mantine-DatePickerInput-input[aria-invalid=\"true\"]:focus-within {\n  border-color: var(--mantine-color-red-6);\n  box-shadow: 0 0 0 1px var(--mantine-color-red-6);\n}\n\n.input-error-icon {\n  color: var(--mantine-color-red-6);\n  display: flex;\n  align-items: center;\n}\n\n.mantine-InputWrapper-error {\n  font-size: var(--mantine-font-size-xs);\n  font-weight: 600;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
